import './App.css';
import React from 'react';
import Topbar from './components/Topbar';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Main from './components/Main';
import Footer from './components/Footer';
import {useTranslation } from "react-i18next";


function App() {
    const { t, i18n } = useTranslation();
    
  return (
    <div>
      <Topbar/>      
      <Navbar/>
      <Hero/>
      <Main/>
      <Footer/>
      { /* Modal Phone*/}
      <div className="modal fade" id="exampleModalCenter" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLongTitle">Old Tbilisi</h5>
                    <i className="fas fa-times" data-bs-dismiss="modal" aria-label="Close"></i>                  
                  </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 center text-center">
                                <div className="modal-contact">                              
                                    <h2>{t("call-us")}</h2>
                                    <p><a className="a-action" href="tel:+3225021729"><i className="fas fa-phone-alt"></i><span className="p-click">{t("click-call")}</span><br></br> +32 2 502 17 29</a> </p>
                                </div> 
                                <div className="modal-contact">
                                    <h2>{t("email-us")}</h2>
                                    <p><a className="a-action" href="mailto: info@oldtbilisi.be">
                                        <i className="fas fa-envelope"></i>
                                        <span className="p-click">{t("click-email")}</span>
                                        <br></br>
                                        info@oldtbilisi.be
                                        </a>
                                    </p>
                                </div> 
                                    <p className="text-center pt-2"><a href="https://www.takeaway.com/be-en/menu/old-tbilisi-georgisch-restaurant" rel="noreferrer" target="_blank">{t("about-us-p-3")}</a></p>
                            </div>                   
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t("close")}</button>                  
                    </div>
                </div>
            </div>
        </div>
        { /* Modal email*/}
        <div className="modal fade" id="exampleModalCenter2" role="dialog" aria-labelledby="exampleModalCenter2Title" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLongTitle">Old Tbilisi</h5>
                        <i className="fas fa-times" data-bs-dismiss="modal" aria-label="Close"></i>                  
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 center text-center">
                                <div className="modal-contact">
                                    <h2>{t("message-us")}</h2>
                                    <button data-bs-dismiss="modal" ><a href="#contact" className="btn btn-menu animated fadeInUp scrollto">{t("message-us-btn")}</a></button>
                                </div> 
                                <div className="modal-contact">
                                    <h2>{t("click-email")}</h2>
                                    <p><a className="a-action" href="mailto: info@oldtbilisi.be"><i className="fas fa-envelope"></i> info@oldtbilisi.be</a></p>
                                </div> 
                            </div> 
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t("close")}</button>
                    </div>
                </div>
            </div>
        </div>    
        { /* Modal maps*/}
        <div className="modal fade" id="exampleModalCenter3" role="dialog" aria-labelledby="exampleModalCenter3Title" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLongTitle">Old Tbilisi</h5>
                        <i className="fas fa-times" data-bs-dismiss="modal" aria-label="Close"></i>                  
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-sm-12 center text-center">
                                <div className="modal-contact">
                                    <h2>{t("our-location")}</h2>
                                    <p><a href=""><i className="fas fa-map-marker-alt mx-2"></i>{t("click-to-nav")}</a> </p>
                                    <p>Nieuwstraat 20, Asse - 1730</p>
                                </div>                        
                            </div>
                            <div className="col-sm-12">
                                <iframe className="img-fluid" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10062.634217937617!2d4.1955733!3d50.9115337!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x3649b5ec367aca9d!2sOld%20Tbilisi!5e0!3m2!1sen!2sbe!4v1633092933572!5m2!1sen!2sbe" width="600" height="450"  allowfullscreen="" loading="lazy"></iframe>
                            </div>              
                        </div>
                        <p className="text-center pt-2"><a href="https://www.takeaway.com/be-en/menu/old-tbilisi-georgisch-restaurant" rel="noreferrer" target="_blank">{t("about-us-p-3")}</a></p>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">{t("close")}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>    
  );
}

export default App;
